import { _CLAIMS_SYS_ADMIN } from '@/app/shared/constants/access.claims';

//================ MENU ASSETS =================
export const _CLAIMS_MENU_ASSETS_R = [..._CLAIMS_SYS_ADMIN, 'MENU.ASSETS-R'] as const;
export const _CLAIMS_MENU_ASSETS_W = [..._CLAIMS_SYS_ADMIN, 'MENU.ASSETS-W'] as const;





export const _CLAIMS_EQP_EQUIPMENTS_R = 'EQP-EQUIPMENTS-R' as const;
export const _CLAIMS_EQP_EQUIPMENTS_W = 'EQP-EQUIPMENTS-W' as const;

export const _CLAIMS_EQP_INSTALLATION_LOCATIONS_R = 'EQP-INSTALLATION-LOCATIONS-R' as const;
export const _CLAIMS_EQP_INSTALLATION_LOCATIONS_W = 'EQP-INSTALLATION-LOCATIONS-W' as const;

export const _CLAIMS_EQP_EQUIPMENT_STATUSES_R = 'EQP-EQUIPMENT-STATUSES-R' as const;
export const _CLAIMS_EQP_EQUIPMENT_STATUSES_W = 'EQP-EQUIPMENT-STATUSES-W' as const;

export const _CLAIMS_EQP_EQUIPMENT_TYPES_R = 'EQP-EQUIPMENT-TYPES-R' as const;
export const _CLAIMS_EQP_EQUIPMENT_TYPES_W = 'EQP-EQUIPMENT-TYPES-W' as const;

export const _CLAIMS_EQP_EQUIPMENT_CLASSES_R = 'EQP-EQUIPMENT-CLASSES-R' as const;
export const _CLAIMS_EQP_EQUIPMENT_CLASSES_W = 'EQP-EQUIPMENT-CLASSES-W' as const;

export const _CLAIMS_EQP_EQUIPMENT_PLANNER_GROUPS_R = 'EQP-EQUIPMENT-PLANNER-GROUPS-R' as const;
export const _CLAIMS_EQP_EQUIPMENT_PLANNER_GROUPS_W = 'EQP-EQUIPMENT-PLANNER-GROUPS-W' as const;

export const _CLAIMS_EQP_MEASURE_DOCUMENTS_R = 'EQP-MEASURE-DOCUMENTS-R' as const;
export const _CLAIMS_EQP_MEASURE_DOCUMENTS_W = 'EQP-MEASURE-DOCUMENTS-W' as const;

export const _CLAIMS_EQP_MEASURE_POINTS_R = 'EQP-MEASURE-POINTS-R' as const;
export const _CLAIMS_EQP_MEASURE_POINTS_W = 'EQP-MEASURE-POINTS-W' as const;

export const _CLAIMS_EQP_MEASURE_UNITS_R = 'EQP-MEASURE-UNITS-R' as const;
export const _CLAIMS_EQP_MEASURE_UNITS_W = 'EQP-MEASURE-UNITS-W' as const;

export const _CLAIMS_EQP_CLASS_ABCS_R = 'EQP-CLASS-ABCS-R' as const;
export const _CLAIMS_EQP_CLASS_ABCS_W = 'EQP-CLASS-ABCS-W' as const;


export const _CLAIMS_AUX_TABLES_R = 'AUX-TABLES-R' as const;
export const _CLAIMS_AUX_TABLES_W = 'AUX-TABLES-W' as const;




//remover
export const _CLAIMS_EQP_R = 'EQP-R' as const;
export const _CLAIMS_EQP_W = 'EQP-W' as const;

export const _CLAIMS_OBJETOS_TECNICOS_R = 'OBJETOS-TECNICOS-R' as const;
export const _CLAIMS_OBJETOS_TECNICOS_W = 'OBJETOS-TECNICOS-W' as const;

export const _CLAIMS_EQP_LOCATION_TYPES_R = 'EQP-LOCATION-TYPES-R' as const;
export const _CLAIMS_EQP_LOCATION_TYPES_W = 'EQP-LOCATION-TYPES-W' as const;

export const _CLAIMS_EQP_STATUSES_R = 'EQP-STATUSES-R' as const;
export const _CLAIMS_EQP_STATUSES_W = 'EQP-STATUSES-W' as const;

export const _CLAIMS_MNT_TECHNICAL_CHARACTERISTICS_R = 'MNT-TECHNICAL-CHARACTERISTICS-R' as const;
export const _CLAIMS_MNT_TECHNICAL_CHARACTERISTICS_W = 'MNT-TECHNICAL-CHARACTERISTICS-W' as const;